import React, { createContext, useContext } from "react";

import {
  useRegistryAgencyNameQuery,
  useRegistryAgencyQuery,
} from "@api/ctg/registryAgencyFilter/registryAgencyFilter";

type RegistryAgencyContextType = {
  RegistryAgencyData: Record<string, string> | null;
  RegistryAgencyNameData: Record<string, string> | null;
  isLoading: boolean;
};

const RegistryAgencyContext = createContext<RegistryAgencyContextType | null>(
  null,
);

export const RegistryAgencyProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { data: RegistryAgencyData, isLoading: isRegistryAgencyLoading } =
    useRegistryAgencyQuery();

  const { data: RegistryAgencyNameData, isLoading: isNameLoading } =
    useRegistryAgencyNameQuery();

  const isLoading = isRegistryAgencyLoading || isNameLoading;

  const value = React.useMemo(
    () => ({
      RegistryAgencyData: RegistryAgencyData || null,
      RegistryAgencyNameData: RegistryAgencyNameData || null,
      isLoading,
    }),
    [RegistryAgencyData, RegistryAgencyNameData, isLoading],
  );

  return (
    <RegistryAgencyContext.Provider value={value}>
      {children}
    </RegistryAgencyContext.Provider>
  );
};

export const useRegistryAgency = () => {
  const context = useContext(RegistryAgencyContext);
  if (!context) {
    throw new Error(
      "useRegistryAgency must be used within a RegistryAgencyProvider",
    );
  }
  return context;
};
